/* Synthagen: dokumenty, polityki, 404, wyszukiwarka i kolekcje (sekcje sgd-*).
   Dokumenty: porządkuje treść, numeruje sekcje, buduje spis treści i podświetla bieżącą sekcję.
   Polityki (/policies/*): przenosi treść Shopify do układu dokumentu (szablon #sgd-tpl z snippetu sgd-policy).
   Karty produktów: dodawanie do koszyka i otwarcie koszyka motywu. */
(function () {
  'use strict';
  var RM = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  function q(s, r) { return (r || document).querySelector(s); }
  function qa(s, r) { return [].slice.call((r || document).querySelectorAll(s)); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function pl(n, a, b, c) { var d = n % 10, h = n % 100; return n === 1 ? a : (d >= 2 && d <= 4 && (h < 12 || h > 14)) ? b : c; }
  function pad(n) { n = String(n); return n.length < 2 ? '0' + n : n; }
  function norm(s) { return String(s || '').replace(/ /g, ' ').replace(/\s+/g, ' ').trim().toLocaleLowerCase('pl'); }
  function root() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }
  function slug(s) {
    s = norm(s).replace(/ł/g, 'l');
    try { s = s.normalize('NFD').replace(/[̀-ͯ]/g, ''); } catch (e) { }
    return s.replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 60) || 'sekcja';
  }
  function caseFix(t) {
    var m = t.match(/^SEKCJA\s+(\d+)\s*[—–-]\s*(.+)$/i), n = '', s = t;
    if (m) { n = m[1] + '. '; s = m[2]; }
    s = s.toLocaleLowerCase('pl'); s = s.charAt(0).toLocaleUpperCase('pl') + s.slice(1);
    s = s.replace(/\bshopify\b/g, 'Shopify').replace(/\b(ue|rodo|krs|nip|regon|vat)\b/g, function (x) { return x.toUpperCase(); });
    return n + s;
  }

  /* wysokość przyklejonego nagłówka motywu (chowa się przy przewijaniu w dół) */
  var hdr = null;
  function top0() { hdr = hdr || q('.header-section header, sticky-header, .header-wrapper'); if (!hdr) return 0; var b = hdr.getBoundingClientRect().bottom; return b > 0 && b < 240 ? Math.round(b) : 0; }
  var lastTop = -1, tq = 0;
  function setTop() { tq = 0; var t = top0(); if (t === lastTop) return; lastTop = t; qa('.sgd').forEach(function (r) { r.style.setProperty('--sgs-top', t + 'px'); }); }

  /* ===== dokument ===== */
  function doc(r) {
    var body = q('[data-sgd-body]', r); if (!body || body.__sgd) return; body.__sgd = 1;
    while (body.children.length === 1 && body.firstElementChild.tagName === 'DIV' && !body.firstElementChild.className) {
      var d = body.firstElementChild; while (d.firstChild) body.insertBefore(d.firstChild, d); d.remove();
    }
    qa('p', body).forEach(function (p) { if (!p.textContent.replace(/ /g, ' ').trim() && !p.querySelector('img,iframe,video,svg,input')) p.remove(); });

    var tEl = q('[data-sgd-title]', r), tt = norm(tEl.textContent), f = body.firstElementChild;
    if (f && /^H[12]$/.test(f.tagName)) {
      var ft = f.textContent.replace(/ /g, ' ').trim();
      if (ft.length < 90 && (f.tagName === 'H1' || norm(ft) === tt || !tt)) { if (!tt) tEl.textContent = ft; f.remove(); }
    }
    for (var i = 0, el = body.firstElementChild; el && i < 3; i++, el = el.nextElementSibling) {
      if (el.tagName !== 'P') continue;
      var m = el.textContent.replace(/ /g, ' ').replace(/\s+/g, ' ').trim().match(/^Ostatnia aktualizacja\s*:?\s*(.{3,40})$/i);
      if (m) { var dc = q('[data-sgd-date]', r); q('[data-sgd-dv]', dc).textContent = m[1].replace(/\.$/, ''); dc.hidden = false; el.remove(); break; }
    }

    /* akapity z samym pogrubionym tekstem (np. „SEKCJA 1 — …”) jako nagłówki */
    qa(':scope > p', body).forEach(function (p) {
      var t = p.textContent.replace(/ /g, ' ').replace(/\s+/g, ' ').trim();
      if (t.length < 2 || t.length > 110 || p.querySelector('br,a,img')) return;
      var ok = [].every.call(p.childNodes, function (n) { return (n.nodeType === 3 && !n.textContent.trim()) || (n.nodeType === 1 && /^(B|STRONG)$/.test(n.tagName)); });
      if (!ok) return;
      var up = t === t.toLocaleUpperCase('pl') && /[A-ZĄĆĘŁŃÓŚŹŻ]{3}/.test(t);
      var h = document.createElement(up ? 'h2' : 'h3'); h.textContent = up ? caseFix(t) : t; p.parentNode.replaceChild(h, p);
    });

    /* dane sprzedawcy jako ramka */
    qa(':scope > p', body).forEach(function (p) {
      var t = p.textContent.replace(/ /g, ' ').trim();
      if (/^(Sprzedawca|Podmiot prowadzący sklep|Administrator danych)\s*:/i.test(t) || (/^AXIOM ONE/.test(t) && p.querySelector('br'))) p.classList.add('co2');
    });

    /* sekcje i spis treści */
    var h2 = qa(':scope > h2', body), h3 = qa(':scope > h3', body), hs = h2.length >= 2 ? h2 : h3, used = {};
    var toc = q('[data-sgd-toc]', r), tl = q('[data-sgd-tl]', r), items = [], NUM = /^(\d{1,2})[.)]\s+(.+)$/;
    var anyNum = hs.some(function (h) { return NUM.test(h.textContent.replace(/ /g, ' ').trim()); });
    hs.forEach(function (h, k) {
      var tx = h.textContent.replace(/ /g, ' ').replace(/\s+/g, ' ').trim(), mm = tx.match(NUM), num = mm ? pad(mm[1]) : anyNum ? '–' : pad(k + 1), lab = mm ? mm[2] : tx;
      var id = h.id || slug(lab); while (used[id] || (document.getElementById(id) && document.getElementById(id) !== h)) id += '-' + (k + 1); used[id] = 1; h.id = id;
      h.classList.add('sec');
      if (mm) h.innerHTML = '<span class="n">' + num + '</span><span>' + esc(lab) + '</span>';
      items.push('<li><a href="#' + esc(id) + '"><small>' + num + '</small><span>' + esc(lab) + '</span></a></li>');
    });
    var words = body.textContent.trim().split(/\s+/).length, mins = Math.max(1, Math.round(words / 200));
    var cm = q('[data-sgd-min]', r); if (cm) { q('b', cm).textContent = mins; cm.hidden = false; }
    var cn = q('[data-sgd-n]', r);
    if (cn && hs.length > 1) { q('b', cn).textContent = hs.length; q('span', cn).textContent = ' ' + pl(hs.length, 'sekcja', 'sekcje', 'sekcji'); cn.hidden = false; }

    var pr = q('[data-sgd-print]', r); if (pr) pr.addEventListener('click', function () { window.print(); });
    var cur = q('.dx a[aria-current]', r), ul = cur && cur.closest('ul'); if (ul && ul.scrollWidth > ul.clientWidth) ul.scrollLeft += cur.getBoundingClientRect().left - ul.getBoundingClientRect().left - 16;

    if (!toc || hs.length < 2) return;
    tl.innerHTML = items.join(''); toc.hidden = false;
    var tc = q('[data-sgd-tc]', r); if (tc) tc.textContent = hs.length;
    var mq = matchMedia('(max-width:1000px)'), aside = q('.dn', r), bar = q('[data-sgd-bar]', r), links = qa('a', tl), on = -1, raf = 0;
    function mode() { toc.open = !mq.matches; }
    mode(); if (mq.addEventListener) mq.addEventListener('change', mode); else if (mq.addListener) mq.addListener(mode);
    q('summary', toc).addEventListener('click', function (e) { if (!mq.matches) e.preventDefault(); });
    links.forEach(function (a, k) {
      a.addEventListener('click', function (e) {
        var h = hs[k]; if (!h) return; e.preventDefault();
        h.scrollIntoView({ behavior: RM ? 'auto' : 'smooth', block: 'start' });
        try { history.replaceState(null, '', '#' + h.id); } catch (x) { }
        if (mq.matches) toc.open = false;
      });
    });
    function keep(a) {
      if (mq.matches || !aside || aside.scrollHeight <= aside.clientHeight + 2) return;
      var at = a.getBoundingClientRect(), bt = aside.getBoundingClientRect();
      if (at.top < bt.top + 48) aside.scrollTop -= bt.top + 48 - at.top; else if (at.bottom > bt.bottom - 16) aside.scrollTop += at.bottom - bt.bottom + 16;
    }
    function spy() {
      raf = 0; var line = (lastTop > 0 ? lastTop : 0) + 140, k = -1;
      for (var i = 0; i < hs.length; i++) { if (hs[i].getBoundingClientRect().top <= line) k = i; else break; }
      if (k !== on) {
        if (on > -1 && links[on]) { links[on].classList.remove('on'); links[on].removeAttribute('aria-current'); }
        on = k; if (k > -1 && links[k]) { links[k].classList.add('on'); links[k].setAttribute('aria-current', 'location'); keep(links[k]); }
      }
      if (bar) { var b = body.getBoundingClientRect(), vh = innerHeight, p = (vh * .4 - b.top) / Math.max(1, b.height - vh * .4); bar.style.transform = 'scaleX(' + Math.min(1, Math.max(0, p)).toFixed(3) + ')'; }
    }
    addEventListener('scroll', function () { if (!raf) raf = requestAnimationFrame(spy); }, { passive: true });
    addEventListener('resize', function () { if (!raf) raf = requestAnimationFrame(spy); });
    spy();
  }

  /* ===== polityki sklepu (/policies/*) ===== */
  function key(p) { p = (p || '').replace(/\/$/, ''); var i = p.indexOf('/policies/'); if (i < 0) i = p.indexOf('/pages/'); return i < 0 ? p : p.slice(i); }
  function policy() {
    var pc = q('.shopify-policy__container'), tpl = document.getElementById('sgd-tpl');
    if (!pc || !tpl || !tpl.content) return;
    var fr = document.importNode(tpl.content, true), r = fr.querySelector('[data-sgd-doc]'); if (!r) return;
    var h1 = pc.querySelector('.shopify-policy__title h1') || pc.querySelector('h1');
    var src = pc.querySelector('.shopify-policy__body .rte') || pc.querySelector('.shopify-policy__body') || pc;
    var t = h1 ? h1.textContent.replace(/\s+/g, ' ').trim() : document.title.split(' – ')[0];
    var here = key(location.pathname), cur = null;
    qa('.dx a', r).forEach(function (a) { var p = ''; try { p = new URL(a.getAttribute('href'), location.href).pathname; } catch (x) { } if (key(p) === here) cur = a; else a.removeAttribute('aria-current'); });
    if (cur) cur.setAttribute('aria-current', 'page');
    q('[data-sgd-title]', r).textContent = t;
    q('[data-sgd-crumb]', r).textContent = cur ? cur.textContent.trim() : t;
    var body = q('[data-sgd-body]', r); if (h1) { var tw = h1.closest('.shopify-policy__title'); if (tw && src.contains(tw)) tw.remove(); }
    while (src.firstChild) body.appendChild(src.firstChild);
    pc.parentNode.insertBefore(r, pc); pc.parentNode.removeChild(pc);
    doc(r);
  }

  /* ===== karty produktów: do koszyka ===== */
  var BAGOK = '<svg viewBox="0 0 24 24" aria-hidden="true"><g fill="none" stroke="currentColor" stroke-linecap="round" stroke-width="1.5"><path d="M3.79424 12.0291C4.33141 9.34329 4.59999 8.00036 5.48746 7.13543C5.65149 6.97557 5.82894 6.8301 6.01786 6.70061C7.04004 6 8.40956 6 11.1486 6H12.8515C15.5906 6 16.9601 6 17.9823 6.70061C18.1712 6.8301 18.3486 6.97557 18.5127 7.13543C19.4001 8.00036 19.6687 9.34329 20.2059 12.0291C20.9771 15.8851 21.3627 17.8131 20.475 19.1793C20.3143 19.4267 20.1267 19.6555 19.9157 19.8616C18.7501 21 16.7839 21 12.8515 21H11.1486C7.21622 21 5.25004 21 4.08447 19.8616C3.87342 19.6555 3.68582 19.4267 3.5251 19.1793C2.63744 17.8131 3.02304 15.8851 3.79424 12.0291Z"/><path d="M9 6.01973V5C9 3.34315 10.3431 2 12 2C13.6569 2 15 3.34315 15 5V6.01973"/><path stroke-linejoin="round" d="M9.5 13.6L11.2 15.4L14.6 11.6"/></g></svg>';
  var toast = null, tt = 0;
  function say(html, err) {
    if (!toast) { toast = document.createElement('div'); toast.setAttribute('role', 'status'); document.body.appendChild(toast); }
    toast.className = 'sgs-toast' + (err ? ' err' : ''); toast.innerHTML = html;
    requestAnimationFrame(function () { toast.classList.add('on'); }); clearTimeout(tt); tt = setTimeout(function () { toast.classList.remove('on'); }, 4200);
  }
  function add(btn) {
    if (btn.disabled) return; var old = btn.innerHTML, name = btn.getAttribute('data-name') || ''; btn.disabled = true; btn.classList.add('busy'); btn.setAttribute('aria-busy', 'true');
    fetch(root() + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: +btn.getAttribute('data-add'), quantity: 1 }] }) })
      .then(function (res) { if (!res.ok) throw res; return res.json(); })
      .then(function () {
        btn.classList.remove('busy'); btn.removeAttribute('aria-busy'); btn.classList.add('ok');
        var sv = btn.querySelector('svg'); if (sv) sv.outerHTML = BAGOK; var lb = btn.querySelector('[data-lbl]'); if (lb) lb.textContent = 'Dodano';
        setTimeout(function () { btn.classList.remove('ok'); btn.innerHTML = old; btn.disabled = false; }, 1900);
        return fetch(root() + 'cart.js', { headers: { 'Accept': 'application/json' } }).then(function (res) { return res.json(); }).then(function (c) {
          qa('cart-count,[data-cart-count]').forEach(function (e) { e.textContent = c.item_count; e.setAttribute('aria-label', c.item_count); });
          var dr = q('cart-drawer');
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: !!dr, cart: c } }));
          document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: c } }));
          if (!dr) say('<i class="ok">' + BAGOK + '</i><span>Dodano: <b>' + esc(name) + '</b></span><a href="' + root() + 'cart">Koszyk</a>');
        });
      })
      .catch(function (res) {
        btn.classList.remove('busy'); btn.removeAttribute('aria-busy'); btn.disabled = false; btn.innerHTML = old;
        var msg = 'Nie udało się dodać do koszyka. Spróbuj ponownie.';
        if (res && res.json) res.json().then(function (j) { say(esc((j && (j.description || j.message)) || msg), true); }).catch(function () { say(msg, true); }); else say(msg, true);
      });
  }

  function boot(r) {
    if (!r || r.__sgdb) return; r.__sgdb = 1;
    if (r.matches('[data-sgd-doc]')) doc(r);
    qa('[data-add]', r).forEach(function (b) { b.addEventListener('click', function () { add(b); }); });
    qa('[data-sgd-sort]', r).forEach(function (s) {
      s.addEventListener('change', function () { var u = new URL(location.href); u.searchParams.set('sort_by', s.value); u.searchParams.delete('page'); location.href = u.toString(); });
    });
  }
  function all() {
    policy();
    qa('.sgd').forEach(boot);
    document.documentElement.classList.remove('sgd-pol');
    lastTop = -1; setTop();
  }
  addEventListener('scroll', function () { if (!tq) tq = requestAnimationFrame(setTop); }, { passive: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
  document.addEventListener('shopify:section:load', function (e) { var r = e.target.querySelector && e.target.querySelector('.sgd'); if (r) { boot(r); lastTop = -1; setTop(); } });
})();
